import React from 'react';

import { QuestionCircleOutlined } from '@ant-design/icons';
import { ErrorMessage } from 'formik';
import moment from 'moment';
import Select from 'antd/lib/select';
import TimePicker from 'antd/lib/time-picker';
import Tooltip from 'antd/lib/tooltip';
import { T } from 'react-translator-component';

import DatePickerCustom from '../../atoms/DatePickerCustom';
import { SEND_MODE, RECURRENCE_OPTIONS } from './scheduleValues';

const cardStyle = (active) => ({
  flex: 1,
  padding: '12px 16px',
  border: `2px solid ${active ? '#1F7A3D' : '#d9d9d9'}`,
  borderRadius: 6,
  cursor: 'pointer',
  background: '#fff',
});

const PushScheduleFields = ({
  values,
  setFieldValue,
  showModeCards = true,
  timezoneLabel,
}) => {
  // Fora do contexto de criação (ex.: editar um agendamento já existente), não faz
  // sentido oferecer "Enviar agora" — o registro já É um agendamento, e sumir com os
  // campos de data/hora sem explicação vira ticket de suporte. Quando os cards não
  // aparecem, os campos abaixo são sempre exibidos.
  const scheduling = !showModeCards || values.sendMode === SEND_MODE.SCHEDULE;
  // Na criação o fuso é o do navegador: é dele que sai o offset de buildScheduledAt e o
  // header X-Timezone-Offset já enviado pelo projeto (moment-timezone não está
  // instalado aqui). Na edição, quem manda é o timezone gravado na série — mostrar
  // GMT-03:00 enquanto o PATCH grava America/Bogota é contradizer o que é salvo.
  const zone = timezoneLabel || `GMT${moment().format('Z')}`;

  return (
    <div style={{ marginTop: 24 }}>
      {showModeCards && (
        <>
          <label style={{ fontWeight: 600, display: 'block', marginBottom: 8 }}>
            {T('Quando enviar')}:
          </label>

          <div style={{ display: 'flex', gap: 12 }}>
            <div
              role='button'
              tabIndex={0}
              style={cardStyle(!scheduling)}
              onClick={() => setFieldValue('sendMode', SEND_MODE.NOW)}
              onKeyPress={() => setFieldValue('sendMode', SEND_MODE.NOW)}
            >
              <strong>{T('Enviar agora')}</strong>
              <div style={{ color: '#666' }}>
                {T('Disparo imediato para os destinatários')}
              </div>
            </div>

            <div
              role='button'
              tabIndex={0}
              style={cardStyle(scheduling)}
              onClick={() => setFieldValue('sendMode', SEND_MODE.SCHEDULE)}
              onKeyPress={() => setFieldValue('sendMode', SEND_MODE.SCHEDULE)}
            >
              <strong>{T('Agendar envio')}</strong>
              <div style={{ color: '#666' }}>{T('Escolha data e hora do disparo')}</div>
            </div>
          </div>
        </>
      )}

      {scheduling && (
        <div style={{ display: 'flex', gap: 12, marginTop: 16, flexWrap: 'wrap' }}>
          <div style={{ minWidth: 180 }}>
            <label>{T('Data do disparo')}*</label>
            <DatePickerCustom
              style={{ width: '100%' }}
              format='DD/MM/YYYY'
              value={values.scheduleDate ? moment(values.scheduleDate) : null}
              disabledDate={(current) => current && current < moment().startOf('day')}
              onChange={(date) => setFieldValue('scheduleDate', date)}
            />
            <ErrorMessage name='scheduleDate' component='div' className='error' />
          </div>

          <div style={{ minWidth: 140 }}>
            <label>{T('Hora do disparo')}*</label>
            <TimePicker
              style={{ width: '100%' }}
              format='HH:mm'
              minuteStep={5}
              value={values.scheduleTime ? moment(values.scheduleTime) : null}
              onChange={(time) => setFieldValue('scheduleTime', time)}
            />
            <ErrorMessage name='scheduleTime' component='div' className='error' />
          </div>

          <div style={{ minWidth: 180 }}>
            <label>{T('Fuso horário')}</label>
            <div style={{ padding: '6px 0', color: '#666' }}>{zone}</div>
          </div>

          <div style={{ minWidth: 180 }}>
            <label>
              {T('Repetição')}{' '}
              {/*
                spec §5.4: a recorrência mensal usa LocalDate.plusMonths, que faz clamp
                para o último dia do mês (31/jan → 28/fev). O spec pede explicitamente
                que isso apareça na UI.
              */}
              <Tooltip
                title={T('Em meses que não têm o dia escolhido, o disparo cai no último dia do mês: 31/01 vira 28/02.')}
              >
                <QuestionCircleOutlined style={{ color: '#888' }} />
              </Tooltip>
            </label>
            <Select
              style={{ width: '100%' }}
              value={values.recurrence || 'NONE'}
              onChange={(value) => setFieldValue('recurrence', value)}
            >
              {RECURRENCE_OPTIONS.map((o) => (
                <Select.Option key={o.value} value={o.value}>{T(o.label)}</Select.Option>
              ))}
            </Select>
          </div>

          {values.recurrence && values.recurrence !== 'NONE' && (
            <div style={{ minWidth: 180 }}>
              <label>{T('Repetir até')}*</label>
              <DatePickerCustom
                style={{ width: '100%' }}
                format='DD/MM/YYYY'
                value={values.recurrenceUntil ? moment(values.recurrenceUntil) : null}
                disabledDate={(current) => current && current < moment().startOf('day')}
                onChange={(date) => setFieldValue('recurrenceUntil', date)}
              />
              <ErrorMessage name='recurrenceUntil' component='div' className='error' />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PushScheduleFields;
